<template>
  <modal :show="showModal" modal-classes="modal-secondary" size="lg">
    <div class="text-center mb-5">
      <h2>{{ $t("SALES_DELIVERIES.VALIDATE_DELIVERY") }}</h2>
    </div>
    <form class="" @submit.prevent="">
      <div
        class="row delivery-item"
        v-for="item in deliveryItemsModel"
        :key="item.id"
      >
        <div class="col-6 delivery-item-name">
          <span class="code text-bold h3">{{ item.code }}</span>
          <span class="name">{{ item.salesDeliverable.name }}</span>
          <span class="except text-muted">{{ item.excerpt }}</span>
        </div>
        <div class="col-2">
          <base-input
            :label="`${$t('COMMON.EXPECTED_QUANTITY')} (*)`"
            :placeholder="$t('COMMON.EXPECTED_QUANTITY')"
            v-model="deliveryItemsModel[item.id].expected_quantity"
            type="number"
            step="1"
            input-classes="form-control-alternative"
            :disabled="true"
          >
          </base-input>
        </div>
        <div class="col-2">
          <base-input
            :label="`${$t('COMMON.DELIVERED_QUANTITY')} (*)`"
            :placeholder="$t('COMMON.DELIVERED_QUANTITY')"
            v-model="deliveryItemsModel[item.id].quantity"
            type="number"
            step="1"
            input-classes="form-control-alternative"
          >
          </base-input>
          <validation-error :errors="apiValidationErrors.quantity" />
        </div>
        <div class="col-2 row">
          <span class="col-12 text-bold h3">{{
            $t("COMMON.UNIT_OF_MEASURE_UNIT")
          }}</span>
          <object-link
            class="col-12"
            :object="deliveryItemsModel[item.id].unitOfMeasureUnit"
          />
        </div>
      </div>
    </form>

    <template slot="footer">
      <button
        type="submit"
        class="btn btn-primary"
        @click="handleSubmit"
        :disabled="loading"
      >
        <span v-if="loading" class="btn-inner--icon">
          <i class="fas fa-spinner fa-spin"></i>
        </span>
        {{ $t("SALES_DELIVERIES.VALIDATE_DELIVERY") }}
      </button>

      <button
        type="button"
        class="btn btn-link ml-auto"
        @click="closeSalesOrderDeliveryForm"
        :disabled="loading"
      >
        {{ $t("COMMON.CLOSE") }}
      </button>
    </template>
  </modal>
</template>

<script>
import {
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  Button,
} from "element-ui";
import { cloneDeep } from "lodash";
import formMixin from "@/mixins/form-mixin";
import requestErrorMixin from "@/mixins/request-error-mixin";
import ValidationError from "@/components/ValidationError.vue";

export default {
  components: {
    ValidationError,
    [Tooltip.name]: Tooltip,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
  },

  mixins: [formMixin, requestErrorMixin],

  props: ["salesDelivery", "showModal"],

  data() {
    this.setDeliveryItemsModel();
    return {
      deliveryItemsModel: [],
      loading: false,
    };
  },

  computed: {},

  methods: {
    setDeliveryItemsModel() {
      const deliveryItemsData = {};
      for (const item of this.salesDelivery.items) {
        deliveryItemsData[item.id] = cloneDeep(item);
      }
      this.deliveryItemsModel = deliveryItemsData;
    },

    closeSalesOrderDeliveryForm() {
      this.$emit("closeSalesOrderDeliveryForm");
    },

    async handleSubmit() {
      try {
        this.loading = true;

        for (const line of Object.values(this.deliveryItemsModel)) {
          const salesDeliveryItemData = _.cloneDeep(line);
          await this.$store.dispatch(
            "salesDeliveryItems/update",
            salesDeliveryItemData
          );
        }
        await this.$store.dispatch(
          "salesDeliveries/validate",
          this.salesDelivery.id
        );

        this.$notify({
          type: "success",
          message: this.$t("SALES_DELIVERIES.SALES_DELIVERY_VALIDATED"),
        });

        this.$emit("salesDeliveryUpdated");
        this.$emit("closeSalesOrderDeliveryForm");
        this.loading = false;
      } catch (error) {
        await this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },
  },

  mounted() {},

  watch: {
    showModal() {
      this.setDeliveryItemsModel();
    },
    salesDelivery() {
      this.setDeliveryItemsModel();
    },
  },
};
</script>
<style scoped>
.delivery-item .delivery-item-name {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>
